module.exports = __webpack_public_path__ + "img/image-placeholder.e5c87965.svg";